import { IPaymentOptionsForUI } from "../../../interfaces/IPayments";

export const PAYMENT_OPTIONS_UI: IPaymentOptionsForUI[] = [
  { value: 'savedCard', type: '', lastFour: '', image: '' },
  { value: 'newCard', type: '', lastFour: '', image: '' },
  { value: 'newBankAccount', type: '', lastFour: '', image: '' },
  { value: 'paze', type: '', lastFour: '', image: '' },
];

export const BANK_TYPE_FOR_UI = 'bank';